import * as React from 'react';

import formatDistanceToNow from 'date-fns/formatDistanceToNow';

interface Props {
  playedAt: Date;
}

export const MatchPendingText = ({ playedAt }: Props) => {
  return (
    <p className="text-center">
      Voting for this match will start in {formatDistanceToNow(playedAt)}.
    </p>
  );
};
